import Vue from "vue";
import Router from "vue-router";
import "@/plugins/register-hooks";

import Home from "@/views/home.vue";
import ServiceProvidersIndex from "@/views/serviceproviders/index.vue";
import ServiceProvidersDetails from "@/views/serviceproviders/details.vue";
import ContentProvidersIndex from "@/views/contentproviders/index.vue";
import ContentProvidersDetails from "@/views/contentproviders/details.vue";
import AssetsIndex from "@/views/assets/index.vue";
import AssetsDetails from "@/views/assets/details.vue";
import AnumberGroupsIndex from "@/views/anumbergroups/index.vue";
import AnumberGroupsDetails from "@/views/anumbergroups/details.vue";
import ProgramContentsIndex from "@/views/programcontents/index.vue";
import ProgramContentsDetails from "@/views/programcontents/details.vue";
import UsersIndex from "@/views/users/index.vue";
import UsersDetails from "@/views/users/details.vue";
import ServiceAccountsIndex from "@/views/serviceaccounts/index.vue";
import ServiceKeysIndex from "@/views/servicekeys/index.vue";
import ANumbersIndex from "@/views/anumbers/index.vue";
import ANumbersDetails from "@/views/anumbers/details.vue";
import MassANumberUploadIndex from "@/views/massanumberuploads/index.vue";
import MassANumberUploadDetails from "@/views/massanumberuploads/details.vue";
import ReportingIndex from "@/views/reporting/index.vue";
import DemosIndex from "@/views/demos/index.vue";
import { Middleware } from "@/models/middleware";

Vue.use(Router);
//router.beforeEach(render.bind(_app))
var permissionMap = Array<String>();
var router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "dashboard",
            component: Home,
            // beforeEnter: (to, from, next) => {
            //     permissionMap = Middleware.buildPermissionMap();
            //     next()
            // }
        },
        {
            path: "/reporting",
            name: "reporting",
            component: ReportingIndex
            // beforeEnter: (to, from, next) => {
            //     permissionMap = Middleware.buildPermissionMap();
            //     next()
            // }
        },
        /*******************SERVICE PROVIDERS */
        {
            path: "/service-providers/:serviceProviderId",
            name: "serviceproviders_details",
            component: ServiceProvidersDetails,
            meta: {
                parent: { name: "serviceproviders_index" },
            },
        },
        {
            path: "/service-providers",
            name: "serviceproviders_index",
            component: ServiceProvidersIndex,
        },

        /*******************CONTENT PROVIDERS */
        {
            path: "/content-providers/:contentProviderId",
            name: "contentproviders_details",
            component: ContentProvidersDetails,
            meta: {
                parent: { name: "contentproviders_index" },
            },
        },
        {
            path: "/content-providers",
            name: "contentproviders_index",
            component: ContentProvidersIndex,
        },

        /***************ASSETS */
        {
            path: "/assets/:assetId",
            name: "assets_details",
            component: AssetsDetails,
            meta: {
                parent: { name: "assets_index" },
            },
        },
        {
            path: "/assets",
            name: "assets_index",
            component: AssetsIndex,
        },

        /***************PROGRAM CONTENTS */
        {
            path: "/program-contents/:contentId",
            name: "programcontents_details",
            component: ProgramContentsDetails,
            beforeEnter: (to, from, next) => {
                var temp = localStorage.getItem("contentId");
                next();
            },
            meta: {
                parent: { name: "programcontents_index" },
            },
        },
        {
            path: "/program-contents",
            name: "programcontents_index",
            component: ProgramContentsIndex,
            beforeEnter: (to, from, next) => {
                var temp = localStorage.getItem("contentId");
                next();
            },
        },

        /**************USERS */
        {
            path: "/scoped-users/:userId",
            name: "scopedusers_details",
            component: UsersDetails,
            meta: {
                parent: { name: "scopedusers_index" },
            },
        },
        {
            path: "/scoped-users",
            name: "scopedusers_index",
            component: UsersIndex,
        },
        {
            path: "/scoped-contentprovider-users",
            name: "scopedcontentproviderusers_index",
            component: UsersIndex,
        },
        {
            path: "/unscoped-users/:userId",
            name: "unscopedusers_details",
            component: UsersDetails,
            meta: {
                parent: { name: "unscopedusers_index" },
            },
        },
        {
            path: "/unscoped-users",
            name: "unscopedusers_index",
            component: UsersIndex,
        },

        /*****************SERVICE ACCOUNTS */
        {
            path: "/unscoped-service-accounts",
            name: "unscopedserviceaccounts_index",
            component: ServiceAccountsIndex,
        },
        {
            path: "/unscoped-servicekeys/:serviceAccountId",
            name: "unscopedservicekeys_index",
            component: ServiceKeysIndex,
            meta: {
                parent: { name: "unscopedserviceaccounts_index" },
            },
        },
        {
            path: "/scoped-service-accounts",
            name: "scopedserviceaccounts_index",
            component: ServiceAccountsIndex,
        },
        {
            path: "/scoped-servicekeys/:serviceAccountId",
            name: "scopedservicekeys_index",
            component: ServiceKeysIndex,
            meta: {
                parent: { name: "scopedserviceaccounts_index" },
            },
        },

        /*****************ANUMBERS*/
        {
            path: "/anumbers/:phoneNumber",
            name: "anumbers_details",
            component: ANumbersDetails,
            meta: {
                parent: { name: "anumbers_index" },
            },
        },
        {
            path: "/anumbers",
            name: "anumbers_index",
            component: ANumbersIndex,
        },
        {
            path: "/mass-anumber-uploads/:massAnumberUploadId",
            name: "massupload_details",
            component: MassANumberUploadDetails,
            meta: {
                parent: { name: "massupload_index" },
            },
        },
        {
            path: "/bulk-actions",
            name: "massupload_index",
            component: MassANumberUploadIndex,
        },
        {
            path: "/anumber-groups/:aNumberGroupsId",
            name: "anumbergroups_details",
            component: AnumberGroupsDetails,
            meta: {
                parent: { name: "anumbergroups_index" },
            },
        },
        {
            path: "/anumber-groups",
            name: "anumbergroups_index",
            component: AnumberGroupsIndex,
        },

        /***************REPORT */
        {
            path: "/report",
            name: "report",
            component: DemosIndex,
        },

        /***************DEMOS */
        {
            path: "/demos",
            name: "demos",
            component: DemosIndex,
        },
        {
            path: "*",
            redirect: "/",
        },
    ],
});

 router.beforeEach((to, from, next) => {
    permissionMap = Middleware.buildPermissionMap();
    if (permissionMap.includes(to.name!)) {
        localStorage.removeItem("alertMessage");
        console.log("permission");
        next();
    } else {
        console.log("no permission");

        router.push({
            name: "dashboard",
        });
        localStorage.setItem("alertMessage", "Access Denied to :  " + to.path);
    }
}); 

router.afterEach((to, from) => {
    console.log("Changing route to: " + to.path);
    gtag("config", googleAnalyticsAccount, {
        page_title: to.name,
        page_path: to.name,
    });
});

export default router;
